function copyShareUrl(node) {
	const url = node.dataset.href || window.location;

	try {
		navigator.clipboard.writeText( url );

		const confirm = document.createElement('div');
		confirm.classList.add('share__confirm');
		confirm.appendChild( document.createTextNode( 'Copied!' ) );

		node.classList.add('share__link--copied');
		node.appendChild( confirm );

		setTimeout( () => {
			node.classList.remove('share__link--copied');
			confirm.parentNode.removeChild( confirm );
		}, 4000 );
	} catch ( fault ) {
		console.error( fault );
	}
}

function init( selector = '.share__link--copy' ) {
	const nodes = document.querySelectorAll(selector);

	nodes.forEach(node => node.addEventListener('click', (e) => {
		e.preventDefault();
		copyShareUrl(node);
	}));
}

export default init();
